import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * RumahKira logo mark + wordmark
 */
const BrandLogo = ({ size = 32, showName = true, sx }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '28%',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <svg viewBox="0 0 24 24" width={size * 0.6} height={size * 0.6} aria-hidden="true">
        <path d="M3 11.2 12 4l9 7.2" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.5 10v9.5h13V10" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        <path d="M9.5 19.5v-5h5v5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
      </svg>
    </Box>
    {showName && (
      <Typography component="span" sx={{ fontWeight: 800, letterSpacing: '-0.02em', fontSize: size * 0.56, lineHeight: 1 }}>
        RumahKira<sup style={{ fontSize: '0.5em', fontWeight: 600 }}>™</sup>
      </Typography>
    )}
  </Box>
);

export default BrandLogo;
